export default "__VITE_ASSET__1fdfe919__"